module.exports = __webpack_public_path__ + "img/feature_buy_en.2997de64.png";